import React from 'react'

import { colors, SH1, SH3, Stack, XStack } from '@zet/design-system'
import Avatar from '@zet/design-system/avatar/Avatar'
import { getName } from '@zet/utils/stringConversion'
import { CustomHeader } from '@zet/zet-pro-quick-journey'
import { useUnsafeVariable } from 'nativewind'

interface IProps {
  customerName?: string
  customerPhoneNumber?: string | number | undefined
}

const BrandAgentHeader: React.FC<IProps> = ({
  customerName,
  customerPhoneNumber,
}) => {
  const [colorSecondary600] = useUnsafeVariable('--color-secondary-600')
  const [colorWhite14] = useUnsafeVariable('--color-white-14')

  return (
    <Stack
      style={{
        backgroundColor: colorSecondary600 || colors.primary[200],
      }}
    >
      <CustomHeader
        bgColor={colorSecondary600 || colors.primary[200]}
        btnColor={colorWhite14 || '#fff'}
      />
      <Stack className="pb-2">
        <XStack className="mx-3 items-center justify-between">
          <XStack className="items-center">
            <Avatar name={customerName} size="large" />
            <Stack className="ml-3">
              {Boolean(customerName) && (
                <SH1 className="break-words text-white" style={{ width: 200 }}>
                  {getName(customerName + '')}
                </SH1>
              )}
              {Boolean(customerPhoneNumber) && (
                <SH3 className="text-grays-40 break-words">
                  {customerPhoneNumber}
                </SH3>
              )}
            </Stack>
          </XStack>
        </XStack>
      </Stack>
    </Stack>
  )
}

export default BrandAgentHeader
